import './UserProfile.sass';

import React from 'react';
import { Button, Col, Modal, ModalBody, Row } from 'react-bootstrap';
import _ from 'underscore';

import ChangeExamContainer from '../../components/ChangeExam/components/ChangeExamContainer';
import {
  getCycles,
  getDutyStates,
  getRanks,
  getSizeShirtTypes,
  getSubcsriptionTypes,
} from '../../utilities/getItemsHelper';
import addAbilityToOpenModal from '../../utilities/modalHOC';
import { canPerformAction } from '../../utilities/permissionUtils';
import { calculateGuestExpiration } from '../../utilities/studentSubscriptionHelper';
import Card from '../Card/Card';
import CheckBoxList from '../CheckBoxList/CheckBoxList';
import { SimpleDatePicker } from '../Datepicker/Datepicker';
import ChangeStripeId from '../Modals/ChangeStripeId/ChangeStripeId';
import ConfirmationPassword from '../Modals/ConfirmationPassword/ConfirmationPassword';
import ConfirmDeletion from '../Modals/ConfirmDeletion/ConfirmDeletion';
import HistorySubscriptions from '../Modals/HistorialSubscriptions/HistorySubscriptions';
import ResetPassword from '../Modals/ResetPassword/ResetPassword';
import SimpleConfirmation from '../Modals/SimpleConfirmation/SimpleConfirmation';
import Spinner from '../Spinner/Spinner';
import CardRow from './CardRow';

const OCCUPATIONAL_SUBSCTIPTION = 'PFE + Occupational';
const PFE_ONLY_SUBSCTIPTION = 'PFE only';
const NO_USER_SUBSCTIPTION = 'No active subscription';

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideRequest: false,
      showPracticeExamModal: false,
      practiceExam: null,
      resetExamConfirmation: false,
      username: false,
      getUserVerifcation: true,
      isBlockUserModalOpen: false,
      iOStoStripe: false,
      guestAccountChecked: false,
      guestStripeId: '',
      guestTransactionId: '',
      guestAccountModalOpen: false,
      guestAccountExpiration: null,
    };
  }

  componentWillMount() {
    this.props.loadRates();
    const query = `rank=${this.props.profile.rank}&dutyState=${this.props.profile.dutyState}&userId=${this.props.profile.id}`;
    this.props.loadCycles(query);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.restartPracticeExamSuccess) {
      this.props.setRestartPracticeExamSuccess(false);
      this.openPracticeExamModal(false, null);
    }
    if (nextProps.userVerification && this.state.getUserVerifcation) {
      this.props.getUserVerification(nextProps.userVerification.user);
      this.setState({
        getUserVerifcation: false,
      });
    }
  }

  setIOStoStripe() {
    this.setState({
      iOStoStripe: !this.state.iOStoStripe,
    });
  }

  isUserCycleActive = () => {
    const { cycles, profile } = this.props;
    if (!cycles || !profile?.cycleSelected) return true;
    const userCycle = cycles.find((c) => c.id === profile.cycleSelected);
    return userCycle?.isActive || false;
  };

  componentDidUpdate(prevProps) {
    if (prevProps.countByDate !== this.props.countByDate) {
      if (
        Array.isArray(this.props.countByDate) &&
        this.props.countByDate.length > 0
      ) {
        const hasIosToStripeAction = this.props.countByDate.some(
          (count) => count.action === 'fromIosToStripe',
        );
        if (hasIosToStripeAction && !this.state.iOStoStripe) {
          this.setState({ iOStoStripe: true });
        }
      }
    }
    if (
      prevProps.loadingSubscriptionHistory !==
      this.props.loadingSubscriptionHistory
    ) {
      if (!this.props.loadingSubscriptionHistory) {
        this.props.openModal({
          modalTitle: 'History User Subscriptions',
          modalContent: (
            <HistorySubscriptions
              onCancel={this.props.closeModal}
              userSubscriptionHistory={this.props.userSubscriptionHistory}
            />
          ),
        });
      }
    }
  }

  openPracticeExamModal = (value, pe) => {
    this.setState({
      showPracticeExamModal: value,
      practiceExam: pe,
      resetExamConfirmation: false,
    });
  };

  openToggleActiveModal = () => {
    const { profile } = this.props;

    this.props.openModal({
      modalTitle: `${profile.active ? 'Disabling' : 'Enabling'} a user`,
      modalContent: (
        <SimpleConfirmation
          onConfirm={() =>
            this.props.onToggleActive(profile.id, profile.active)
          }
          onCancel={this.props.closeModal}
          text={
            <div>
              {`Are you sure you want to ${
                profile.active ? 'disable' : 'enable'
              } `}
              <strong>
                {profile.name} {profile.lastName}
              </strong>
              ?
            </div>
          }
        />
      ),
    });
  };

  openDeleteUserModal = () => {
    const { profile } = this.props;

    this.props.openModal({
      modalTitle: 'Deleting a user',
      modalContent: (
        <ConfirmDeletion
          onSubmit={() => this.props.onDelete(profile.id)}
          message={`You are about to delete the user ${profile.name} ${profile.lastName}.`}
          onCancel={this.props.closeModal}
        />
      ),
    });
  };

  openResetUserQuestionsModal = () => {
    const { profile } = this.props;

    this.props.openModal({
      modalTitle: 'Reset user questions',
      modalContent: (
        <ConfirmDeletion
          onSubmit={() => this.props.onResetUserQuestions(profile.id)}
          message="You are about to reset the user questions?"
          onCancel={this.props.closeModal}
        />
      ),
    });
  };

  resetPasswordModal = () => {
    this.props.openModal({
      modalTitle: 'Reseting a user password',
      modalContent: (
        <ResetPassword
          onSubmit={(fields) =>
            this.props.onResetPassword(this.props.profile.id, fields)
          }
          onCancel={this.props.closeModal}
          user={this.props.profile}
        />
      ),
    });
  };

  // Nuevo - confirm unlocked user modal - reference: openToggleActiveModal
  unlockUserModal = () => {
    const { profile } = this.props;

    this.props.openModal({
      modalTitle: 'Unlock user',
      modalContent: (
        <SimpleConfirmation
          onConfirm={() => this.props.onUnlockUser(profile.id)}
          onCancel={this.props.closeModal}
          text={
            <div>
              Are you sure you want to unlock
              <strong>
                {profile.name} {profile.lastName}
              </strong>
              ?
            </div>
          }
        />
      ),
    });
  };

  historySubscriptions = () => {
    this.props.getUserSubscriptionUser(this.props.profile.id);
  };

  blockUserModal = () => {
    const { profile } = this.props;
    this.props.openModal({
      modalTitle: profile.isBlocked ? 'Unblock user' : 'Block user',
      modalContent: (
        <SimpleConfirmation
          onConfirm={() => this.props.blockUser(profile.id, !profile.isBlocked)}
          onCancel={this.props.closeModal}
          text={
            <div>
              Are you sure you want to{' '}
              {profile.isBlocked ? 'unblock ' : 'block '}
              <strong>
                {profile.name} {profile.lastName}
              </strong>
              ?
            </div>
          }
        />
      ),
    });
  };

  openChangeStripeIdModal = () => {
    this.props.openModal({
      modalTitle: `Change stripe id for ${this.props.profile.email}`,
      modalContent: (
        <ChangeStripeId
          onSubmit={(fields) => this.props.updateUser(fields)}
          onCancel={this.props.closeModal}
          user={this.props.profile}
        />
      ),
    });
  };

  openChangeExamModal = () => {
    this.props.openModal({
      modalTitle: `Change exam for ${this.props.profile.email}`,
      modalContent: (
        <ChangeExamContainer
          onSubmit={(fields) => this.props.updateUser(fields)}
          onCancel={this.props.closeModal}
          user={this.props.profile}
        />
      ),
    });
  };

  CheckBoxListChange = (id) => {
    this.props.changeRole(this.props.profile, id);
  };

  itemsForCheckboxList = (roles, profile) => {
    const items = [{ name: 'Super admin', checked: profile.isSuperAdmin }];
    const itemsAux = roles.map((role) => {
      role.checked = !!(
        _.find(profile.roles, { id: role.id }) && !items[0].checked
      );
      role.disabled = !!items[0].checked;
      return role;
    });
    return items.concat(itemsAux);
  };

  renderThirdInput = (forAdmin, roles, profile) => {
    if (forAdmin) {
      return (
        <div className="roles-list">
          <div className="roles-list-title">Roles</div>
          <CheckBoxList
            items={this.itemsForCheckboxList(roles, profile)}
            onChange={this.CheckBoxListChange}
          />
        </div>
      );
    }
  };

  buttons = (forAdmin, profile, roles) => (
    <div className="buttonsContainer">
      <Row>
        <Col xs={4} md={4}>
          <button
            className="btn btn-sm btn-primary resetPwd"
            onClick={this.resetPasswordModal}
          >
            Reset password
          </button>
        </Col>
        <Col xs={8} md={8}>
          <button
            className="btn btn-sm btn-primary disableUser"
            onClick={this.openToggleActiveModal}
          >
            {profile?.active ? 'Disable user' : 'Enable user'}
          </button>
        </Col>
      </Row>
      <Row>
        <Col xs={4} md={4}>
          {this.renderThirdInput(forAdmin, roles, profile)}
        </Col>
        <Col xs={8} md={8}>
          <button
            className="btn btn-sm btn-primary deleteUser"
            onClick={this.openDeleteUserModal}
          >
            Delete User
          </button>
        </Col>
      </Row>
      {!forAdmin && (
        <Row>
          <Col xs={4} md={4}>
            <button
              className="btn btn-sm btn-primary changeStripeIdBtn"
              onClick={() => this.openChangeStripeIdModal(profile)}
            >
              Change stripe id
            </button>
          </Col>
        </Row>
      )}
    </div>
  );

  updateUserProperties = (user, isRate) => {
    if (isRate && user.rate) {
      const selectedRate = this.props.rates.find((i) => i.id === user.rate);
      if (selectedRate && selectedRate.password) {
        this.onShowRatePasswordModal(user, selectedRate.password);
        return;
      }
    }

    this.props.updateUser(user, user.username);
    this.props.updateCycle();
  };

  updateUserVerification = (update) => {
    this.props.setUserVerification(this.props.userVerification.user, update);
    this.setState({ getUserVerifcation: true });
  };

  onShowRatePasswordModal = (user, ratePassword) => {
    this.props.openModal({
      modalContent: (
        <ConfirmationPassword
          onSubmit={(password) => {
            if (ratePassword !== password) {
              this.props.onShowNotification('Error wrong password');
              this.props.closeModal();
              return;
            }
            user.ratePassword = password;
            this.props.updateUser(user);
          }}
          onCancel={this.props.closeModal}
          title="Please type the rate password "
          submitBtnText="Save"
        />
      ),
      modalClassName:
        'modal-create-chapter grey-modal-body manual-red-component',
    });
  };

  cardRowUserVerification = (
    permissions = this.props.permissions,
    nameForValue = '',
    name,
    value,
    noEditable = false,
    isPassword = false,
    items = [],
    load = () => {},
    select = false,
    isRate = false,
  ) => (
    <CardRow
      valueName={name}
      value={value}
      noEditable={noEditable}
      updateUser={this.updateUserVerification}
      userVerification={this.props.userVerification}
      isPassword={isPassword}
      items={items}
      load={load}
      select={select}
      isRate={isRate}
      nameForValue={nameForValue}
      textArea={name === 'Address User Verification'}
      editable={canPerformAction('Accounts.Students.Manage', permissions)}
    />
  );

  cardRow = (
    permissions = this.props.permissions,
    nameForValue = '',
    name,
    value,
    noEditable = false,
    isPassword = false,
    items = [],
    load = () => {},
    select = false,
    isRate = false,
  ) => (
    <CardRow
      valueName={name}
      value={value}
      updateUser={this.updateUserProperties}
      noEditable={noEditable}
      profile={this.props.profile}
      isPassword={isPassword}
      items={items}
      load={load}
      select={select}
      isRate={isRate}
      nameForValue={nameForValue}
      editable={canPerformAction('Accounts.Students.Manage', permissions)}
      iOStoStripe={this.state.iOStoStripe}
      stripeId={this.props.profile.stripeId}
      setIOStoStripe={() => this.setIOStoStripe()}
    />
  );

  getNameForRank = (rank) => {
    switch (rank) {
      case 'E5':
        return 'E-5';
      case 'E6':
        return 'E-6';
      default:
        return rank;
    }
  };

  updateSubscription = (sub) => {
    const subscription = {
      id: this.props.userSubscription.id,
      isOccupational: sub.type === OCCUPATIONAL_SUBSCTIPTION,
    };
    this.props.updateUserSubscription(subscription);
  };

  getPracticeExamsContent = (practiceExams) => {
    if (practiceExams.length === 0) {
      return (
        <div className="contents cardRowContainer row">
          <div className="col-lg-4 col-md-12 col-sm-12 pr-0 title">
            Practice Exams
          </div>
          <div className="middleColumn col-lg-6 col-md-10 col-xs-10">
            <strong>No records found</strong>
          </div>
        </div>
      );
    }
    const pe = this.state.practiceExam;
    const resSum = pe ? JSON.parse(pe.resultsSummarized) : null;
    return (
      <div className="contents cardRowContainer row" style={{ width: '100%' }}>
        <div className="col-lg-4 col-md-12 col-sm-12 pr-0 title">
          Practice Exams
        </div>
        <div className="middleColumn col-lg-8 col-md-12 col-xs-12">
          {practiceExams.map((pe) => {
            const text = pe.bonus
              ? 'Bonus Practice Exam'
              : pe.extra
                ? 'Extra Practice Exam'
                : pe.free
                  ? 'Free Practice Exam'
                  : 'Paid Practice Exam';
            return (
              <div className="pe-row">
                <span className="pe-name">{text}</span>
                <button
                  className="btn btn-warning pe-button"
                  onClick={() => this.openPracticeExamModal(true, pe)}
                >
                  OPEN
                </button>
              </div>
            );
          })}
        </div>
        <Modal
          className="practice-exam-modal"
          show={this.state.showPracticeExamModal}
        >
          {pe && resSum && (
            <ModalBody className="pe-modal-body">
              <i
                className="fa fa-close close-icon"
                onClick={() => this.openPracticeExamModal(false, null)}
              />
              <div className="big-title">Practice Exam Summary</div>
              <hr />
              <div className="detail-row">
                <span className="detail-title">Correct Answers</span>
                <span className="detail-value">
                  {resSum.correctAnswers.value}/{resSum.totalQuestions}
                </span>
                <span className="detail-points">
                  {`+${resSum.correctAnswers.points} points`}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-title">Accuracy</span>
                <span className="detail-value">{resSum.accuracy.value}%</span>
                <span className="detail-points">
                  {`+${resSum.accuracy.points} points`}
                </span>
              </div>
              <div className="detail-row">
                <span className="detail-title">Time Elapsed</span>
                <span className="detail-value">{resSum.timeElapsed.value}</span>
                <span className="detail-points">
                  {`+${resSum.timeElapsed.points} points`}
                </span>
              </div>
              <hr />
              {!this.state.resetExamConfirmation && (
                <div className="pe-modal-footer">
                  <button
                    className="reset-exam-button btn btn-primary ml-auto mr-0"
                    onClick={() => this.resetExam(true)}
                  >
                    RESET PRACTICE EXAM
                  </button>
                </div>
              )}
              {this.state.resetExamConfirmation && (
                <div className="pe-modal-footer">
                  <span className="confirmation-text">
                    Are you sure you want to reset this practice exam?
                  </span>
                  {!this.props.restartPracticeExamWaiting && (
                    <button
                      className="reset-exam-button btn btn-primary ml-auto mr-0"
                      onClick={() => this.resetExam(false)}
                    >
                      YES, CONTINUE
                    </button>
                  )}
                  {this.props.restartPracticeExamWaiting && <Spinner />}
                </div>
              )}
            </ModalBody>
          )}
        </Modal>
      </div>
    );
  };

  resetExam = (value) => {
    if (value) {
      this.setState({ resetExamConfirmation: true });
    } else {
      this.props.restartPracticeExam(
        this.state.practiceExam.id,
        this.props.profile.id,
      );
    }
  };

  getCycleFromUser = () => {
    const auxCycles = this.props.cycles;

    let selectedCycle = null;

    if (auxCycles && auxCycles.length > 0) {
      selectedCycle = auxCycles.find(
        (cycle) => cycle.id === this.props.profile.cycleSelected,
      );
    }
    return selectedCycle ? selectedCycle.title : '';
  };

  renderDoubleSubscriptionInfo = (permissions) => {
    const { doubleSubStatus, loadingDoubleSubInfo } = this.props;

    // While data is loading and there is no doubleSubStatus yet
    if (loadingDoubleSubInfo && !doubleSubStatus) {
      return (
        <div className="separatorLineMargin">
          <Spinner />
        </div>
      );
    }

    // If doubleSubStatus does not exist, render nothing
    if (!doubleSubStatus) {
      return null;
    }

    const {
      hasDoubleSubscription,
      id,
      confirmedCancellation,
      optedOut,
      lastSeenAt,
    } = doubleSubStatus;

    // If there is no double subscription
    if (!hasDoubleSubscription) {
      return (
        <div className="separatorLineMargin">
          {this.cardRow(
            permissions,
            'hasDoubleSubscription',
            'Double Subscription Detected',
            'NO',
            true,
          )}
        </div>
      );
    }

    // If there is a double subscription
    const rows = [
      { label: 'Double Subscription Detected', value: 'YES' },
      id && {
        label: 'Has Canceled Subscription',
        value: confirmedCancellation ? 'YES' : 'NO',
      },
      id && {
        label: 'Opted Out of Message',
        value: optedOut ? 'YES' : 'NO',
      },
      id && {
        label: 'Last Message Seen:',
        value: lastSeenAt
          ? new Date(Number(lastSeenAt)).toLocaleDateString('en-US')
          : '',
      },
    ].filter(Boolean);

    return (
      <div className="separatorLineMargin">
        {rows.map(({ label, value }) =>
          this.cardRow(
            permissions,
            'hasDoubleSubscription',
            label,
            value,
            true,
          ),
        )}
      </div>
    );
  };

  cardContent = (permissions) => {
    const DutyStates = getDutyStates();
    const Ranks = getRanks();
    DutyStates.splice(0, 1);
    Ranks.splice(0, 1);
    const hasSubscription = this.props.userSubscription.id;
    const { practiceExams, practiceExamsLoading, couponUser, profile } =
      this.props;
    const couponName =
      (profile && profile.coupon) || (couponUser && couponUser.name) || '';
    return (
      <Row className="cardContentWrapper">
        {this.cardRow(
          permissions,
          'isActive',
          'Status',
          this.props.profile
            ? this.props.profile.active
              ? 'Enabled'
              : 'Disabled'
            : '',
          true,
        )}
        {this.cardRow(
          permissions,
          'isBlocked',
          'Block Status',
          this.props.profile && this.props.profile.isBlocked
            ? 'Blocked'
            : 'Not Blocked',
          true,
        )}
        {this.cardRow(
          permissions,
          'id',
          'User ID',
          this.props.profile ? this.props.profile.id : '',
          true,
        )}
        {this.cardRow(permissions, 'team', 'Team', '')}
        {this.cardRow(
          permissions,
          'name',
          'First name',
          this.props.profile ? this.props.profile.name : '',
        )}
        {this.cardRow(
          permissions,
          'lastName',
          'Last name',
          this.props.profile ? this.props.profile.lastName : '',
        )}
        {this.cardRow(
          permissions,
          'username',
          'Username',
          this.props.profile ? this.props.profile.username : '',
        )}
        {this.cardRow(
          permissions,
          'email',
          'Email',
          this.props.profile ? this.props.profile.email : '',
        )}
        {this.cardRow(
          permissions,
          'password',
          'Password',
          '00000000',
          false,
          true,
        )}
        {this.cardRow(
          permissions,
          'phoneNumber',
          'Phone Number',
          this.props.profile
            ? this.props.profile.phoneNumber
              ? `${this.props.profile.countryCode ?? ''} ${this.props.profile.phoneNumber}`
              : 'No phone number added'
            : '',
          false,
        )}
        <div className="separatorLine" />
        {this.renderDoubleSubscriptionInfo(permissions)}
        <div className="separatorLine" />
        <div className="separatorLineMargin">
          {/* RATE SELECT */}
          {this.cardRow(
            permissions,
            'rate',
            'AFSC',
            this.props.profile.rate
              ? {
                  id: this.props.profile.rate.id,
                  name: this.props.profile.rate.shortname,
                }
              : '',
            false,
            false,
            this.props.rates.filter((rate) => rate.name !== 'PFE'),
            () => {},
            true,
            true,
          )}
        </div>
        {/* EXAM PAYGRADE SELECT */}
        {this.cardRow(
          permissions,
          'rank',
          'Exam paygrade',
          this.props.profile.rank ? this.props.profile.rank : '',
          false,
          false,
          Ranks,
          null,
          true,
        )}
        {/* EXAM TYPE */}
        {/* this.cardRow(
          permissions,
          'dutyState',
          'Exam type',
          this.props.profile.dutyState ? this.props.profile.dutyState : '',
          true,
          false,
          DutyStates,
          null,
          true,
        ) */}
        {this.props.showChangeExamTypeModal && (
          <Modal show={this.props.showChangeExamTypeModal}>
            <Modal.Header>
              <Modal.Title>
                Are you trying to switch to the last exam?
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Remember that you must also change the Cycle for Substitute exams,
              after changing the Exam Type
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => {
                  this.props.setShowChangeExamTypeModal(false);
                }}
              >
                Accept
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {/* <Modal show={this.props.showChangeExamTypeModal}>
          <ModalBody> TESTING </ModalBody>
        </Modal> */}
        {/* CYCLE SELECT */}
        {this.cardRow(
          permissions,
          'cycleSelected',
          'Cycle',
          this.props.cycles ? this.getCycleFromUser() : '',
          false,
          false,
          this.props.cycles ? getCycles(this.props.cycles) : null,
          null,
          true,
        )}
        <div className="separatorLine" />

        <div className="separatorLine" />
        <div className="separatorLineMargin">
          {/* FREE ACCOUNT SECTION */}
          {this.renderGuestAccountSection()}
          <div className="separatorLine" />

          {!this.props.profile.isGuestAccount && (
            <div>
              {this.cardRow(
                permissions,
                'stripeId',
                'Stripe ID',
                this.props.profile.stripeId ? (
                  <a
                    href={`https://dashboard.stripe.com/customers/${this.props.profile.stripeId}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Stripe Profile
                  </a>
                ) : (
                  ''
                ),
              )}
              {!this.props.userSubscription.type ? (
                <Spinner />
              ) : (
                <Row className="cardRowContainer" style={{ width: '100%' }}>
                  <Col xs={12} md={12} lg={4} style={{ paddingRight: '0px' }}>
                    <div className="valueName">Subscription</div>
                  </Col>
                  <Col xs={12} md={12} lg={8} style={{ paddingRight: '0px' }}>
                    <div className="value">
                      {this.props.userSubscription.type}
                    </div>
                  </Col>
                </Row>
              )}
              {this.props.userSubscription.type &&
                this.props.userSubscription.type !== NO_USER_SUBSCTIPTION && (
                  <>
                    <CardRow
                      valueName="Subscription Type"
                      nameForValue="type"
                      value={
                        !hasSubscription
                          ? 'The user has no subcription'
                          : this.props.userSubscription.isOccupational
                            ? OCCUPATIONAL_SUBSCTIPTION
                            : PFE_ONLY_SUBSCTIPTION
                      }
                      updateUser={this.updateSubscription}
                      profile={{}}
                      items={getSubcsriptionTypes()}
                      load={() => {}}
                      select
                      isRate={false}
                      editable={
                        hasSubscription &&
                        canPerformAction(
                          'Accounts.Students.Manage',
                          permissions,
                        )
                      }
                    />
                    <CardRow
                      valueName="Coupon"
                      nameForValue="coupon"
                      value={couponName}
                      updateUser={(value) =>
                        this.props.updateUser({
                          id: this.props.profile.id,
                          ...value,
                        })
                      }
                      profile={{}}
                      items={this.coupons()}
                      load={() => {}}
                      select
                      isRate={false}
                      editable={
                        hasSubscription &&
                        canPerformAction(
                          'Accounts.Students.Manage',
                          permissions,
                        )
                      }
                    />
                  </>
                )}
            </div>
          )}
        </div>

        <div className="separatorLine" />
        {/* Order Id */}
        <div className="separatorLineMargin">
          {this.cardRow(permissions, 'orderId', 'Order ID', '')}
          {!this.props.profile.isGuestAccount &&
            this.cardRow(
              permissions,
              'transactionIosId',
              'Transaction ID',
              this.props.profile.transactionIosId,
            )}
        </div>
        <div className="separatorLine" />

        {/* Referred Section */}
        <div className="separatorLineMargin">
          {this.cardRow(
            permissions,
            'referredBy',
            'Referred by',
            this.props.profile.referredBy || 'No referral',
            true, // No editable
          )}
          {this.cardRow(
            permissions,
            'referRequests',
            'Refer requests',
            `${this.props.profile.referralCount || 0} requests`,
            true, // No editable
          )}
        </div>
        <div className="separatorLine" />

        {/* User Verification */}
        <div className="separatorLineMargin">
          {!this.props.userSubscription.type ? (
            <Spinner />
          ) : (
            <div>
              {this.props.userVerification?.yourText ? (
                <div>
                  {this.cardRowUserVerification(
                    permissions,
                    'yourText',
                    'Address User Verification',
                    this.props.userVerification?.yourText || '',
                  )}
                  {this.props.userVerification?.tShirtSize && (
                    <CardRow
                      valueName="T-Shirt Size"
                      nameForValue="tShirtSize"
                      value={
                        this.props.userVerification.tShirtSize || [
                          'S',
                          'M',
                          'L',
                          'XL',
                          'XXL',
                        ]
                      }
                      updateUser={this.updateUserVerification}
                      userVerification={this.props.userVerification}
                      profile={{}}
                      items={getSizeShirtTypes()}
                      load={() => {}}
                      select
                      isRate={false}
                      editable={this.props.userVerification?.tShirtSize || ''}
                    />
                  )}

                  {this.cardRowUserVerification(
                    permissions,
                    'email',
                    'Email',
                    this.props.userVerification?.email || '',
                  )}

                  {this.cardRowUserVerification(
                    permissions,
                    'lastName',
                    'Last Name',
                    this.props.userVerification?.lastName || '',
                  )}
                  {this.cardRowUserVerification(
                    permissions,
                    'firstName',
                    'First Name',
                    this.props.userVerification?.firstName || '',
                  )}
                </div>
              ) : (
                <div className="notCycles">
                  <span>User Verification information not available</span>
                </div>
              )}
            </div>
          )}
        </div>
        {this.renderGuestAccountModal()}
      </Row>
    );
  };

  loginAs = (platformType) => {
    this.props.loginAs(
      this.props.profile.id,
      platformType,
      this.props.userAdmin.id,
    );
  };

  coupons = () =>
    this.props.applicableCoupons.map((c) => ({
      id: c.name,
      name: `${c.name} - ${c.description}`,
    }));

  getOptions = (permissions) => {
    const options = [];

    if (canPerformAction('Accounts.Students.LoginAsStudent', permissions)) {
      options.push({
        name: 'Login as student',
        event: () => this.loginAs('web'),
      });
      options.push({
        name: 'Login as student in app',
        event: () => this.loginAs('app'),
      });
    }

    if (canPerformAction('Accounts.Students.EnableStudent', permissions)) {
      options.push({
        name: this.props.profile.active ? 'Disable student' : 'Enable student',
        event: this.openToggleActiveModal,
      });
    }

    if (canPerformAction('Accounts.Students.Manage', permissions)) {
      options.push({
        name: 'Delete student',
        event: this.openDeleteUserModal,
      });
    }

    if (
      canPerformAction('Accounts.Students.ForcePasswordUpdate', permissions)
    ) {
      options.push({
        name: 'Force password update',
        event: this.props.forcePasswordUpdate,
      });
    }

    if (canPerformAction('Accounts.Students.ResetQuestions', permissions)) {
      options.push({
        name: 'Reset questions',
        event: this.openResetUserQuestionsModal,
      });
    }

    if (canPerformAction('Accounts.Students.UnlockUser', permissions)) {
      // Unlock user when is blocked by login attempts, not when is blocked by admin, for this last case we have the option to block/unblock user
      options.push({
        name: 'Unlock user (blocked by login attempts)',
        event: this.unlockUserModal,
      });
    }

    if (
      canPerformAction('Accounts.Students.HistorySubscriptions', permissions)
    ) {
      options.push({
        name: 'History Subscriptions',
        event: this.historySubscriptions,
      });
    }

    if (canPerformAction('Accounts.Students.BlockUser', permissions)) {
      options.push(
        ...(this.props.profile?.isBlocked
          ? [
              {
                name: 'Unblock user',
                event: this.blockUserModal,
              },
            ]
          : [
              {
                name: 'Block user',
                event: this.blockUserModal,
              },
            ]),
      );
    }

    return options;
  };

  renderGuestAccountSection = () => {
    const { profile, permissions } = this.props;
    return (
      <div>
        <Row
          className="cardRowContainer"
          style={{ width: '100%', alignItems: 'center' }}
        >
          <Col xs={12} md={12} lg={4} style={{ paddingRight: '0px' }}>
            <div className="valueName">Free Account</div>
          </Col>
          <Col
            xs={10}
            md={10}
            lg={6}
            style={{ paddingLeft: '0px', paddingRight: '0px' }}
            className="middleColumn"
          >
            <div className="value">{profile.isGuestAccount ? 'Yes' : 'No'}</div>
          </Col>
          <Col
            xs={2}
            md={2}
            lg={2}
            style={{ paddingLeft: '41px', paddingRight: '0px' }}
          >
            <i
              className="fa fa-pencil fa-lg valueName"
              onClick={() =>
                this.setState({
                  guestAccountModalOpen: true,
                  guestAccountChecked: profile.isGuestAccount,
                  guestAccountType: profile.guestAccountType || '',
                  guestAccountExpiration: profile.guestAccountExpiration
                    ? new Date(Number(profile.guestAccountExpiration))
                    : null,
                })
              }
            />
          </Col>
        </Row>
        {profile.isGuestAccount &&
          this.cardRow(
            permissions,
            'guestAccountType',
            'Account Type',
            profile.guestAccountType || '',
            true,
          )}
        {profile.isGuestAccount &&
          this.cardRow(
            permissions,
            'guestAccountExpiration',
            'Expiration Date',
            profile.guestAccountExpiration
              ? new Date(
                  Number(profile.guestAccountExpiration),
                ).toLocaleDateString('en-US')
              : '',
            true,
          )}
        {profile.guestAccountScheduledStart && (
          <div>
            {profile.guestAccountType &&
              this.cardRow(
                permissions,
                'guestAccountType',
                'Scheduled Account Type',
                profile.guestAccountType,
                true,
              )}
            {this.cardRow(
              permissions,
              'guestAccountScheduledStart',
              'Scheduled Free Period',
              <div>
                <div>{`Starts on ${new Date(Number(profile.guestAccountScheduledStart)).toLocaleDateString('en-US')}`}</div>
                {profile.guestAccountExpiration && (
                  <div>{`Finishes on ${new Date(Number(profile.guestAccountExpiration)).toLocaleDateString('en-US')}`}</div>
                )}
              </div>,
              true,
            )}
            <Row
              className="cardRowContainer"
              style={{ width: '100%', marginBottom: '12px' }}
            >
              <Col xs={12} md={12} lg={4} />
              <Col xs={12} md={12} lg={8}>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() =>
                    this.props.updateUser({
                      id: profile.id,
                      cancelGuestAccount: true,
                    })
                  }
                >
                  Cancel Schedule
                </button>
              </Col>
            </Row>
          </div>
        )}
      </div>
    );
  };

  onSaveGuestAccount = () => {
    const { profile } = this.props;
    const {
      guestAccountChecked,
      guestStripeId,
      guestTransactionId,
      guestAccountType,
      guestAccountExpiration,
    } = this.state;

    const isPaidToFree = !profile.isGuestAccount;
    const isEditingExistingSchedule = !!profile.guestAccountScheduledStart;

    const update = {
      id: profile.id,
    };

    if (isEditingExistingSchedule) {
      update.editingGuestSchedule = true;
      update.guestAccountType = guestAccountType;

      if (guestAccountExpiration) {
        update.guestAccountExpiration = guestAccountExpiration.getTime();
      }
    } else if (isPaidToFree) {
      update.isGuestAccount = true;
      update.guestAccountType = guestAccountType;
    } else {
      update.isGuestAccount = guestAccountChecked;
      if (
        guestAccountChecked &&
        profile.isGuestAccount &&
        guestAccountExpiration
      ) {
        update.guestAccountExpiration = guestAccountExpiration.getTime();
      }
      if (!guestAccountChecked && profile.isGuestAccount) {
        if (guestStripeId) {
          update.stripeId = guestStripeId;
          update.updatingStripe = true;
        }
        if (guestTransactionId) {
          update.transactionIosId = guestTransactionId;
          update.updatingTransaction = true;
        }
      }
    }

    this.props.updateUser(update);
    this.setState({
      guestAccountModalOpen: false,
      guestStripeId: '',
      guestTransactionId: '',
      guestAccountType: '',
      guestAccountExpiration: null,
    });
  };

  onCancelGuestPeriod = () => {
    const { profile } = this.props;
    this.props.updateUser({
      id: profile.id,
      cancelGuestAccount: true,
    });
    this.setState({
      guestAccountModalOpen: false,
      guestAccountChecked: false,
      guestStripeId: '',
      guestTransactionId: '',
      guestAccountType: '',
    });
  };

  renderGuestAccountModal = () => {
    const { profile } = this.props;
    const {
      guestAccountModalOpen,
      guestAccountChecked,
      guestStripeId,
      guestTransactionId,
      guestAccountType,
    } = this.state;

    const isPaidToFree = !profile.isGuestAccount;
    const isGuestActive = profile.isGuestAccount;
    const isEditingExistingSchedule = !!profile.guestAccountScheduledStart;

    const saveDisabled =
      isGuestActive &&
      !guestAccountChecked &&
      !guestStripeId &&
      !guestTransactionId;

    const closeModal = () =>
      this.setState({
        guestAccountModalOpen: false,
        guestAccountChecked: profile.isGuestAccount,
        guestStripeId: '',
        guestTransactionId: '',
        guestAccountType: '',
        guestAccountExpiration: null,
      });

    if (!guestAccountModalOpen) return null;

    return (
      <Modal show={guestAccountModalOpen}>
        <Modal.Header>
          <Modal.Title>Free Account</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isPaidToFree && (
            <div>
              {isEditingExistingSchedule && (
                <div className="form-group">
                  <label>Scheduled Start Date</label>
                  <input
                    type="text"
                    className="form-control"
                    value={new Date(
                      Number(profile.guestAccountScheduledStart),
                    ).toLocaleDateString('en-US')}
                    disabled
                  />
                </div>
              )}
              <div className="form-group">
                <label>Account Type</label>
                <select
                  className="form-control"
                  value={guestAccountType || ''}
                  onChange={(e) => {
                    const type = e.target.value;
                    this.setState({
                      guestAccountType: type,
                      guestAccountExpiration: isEditingExistingSchedule
                        ? this.state.guestAccountExpiration
                        : null,
                    });
                  }}
                >
                  <option value="" disabled>
                    Select account type
                  </option>
                  <option value="pfe-skt-semi">PFE-SKT Semi-Annual</option>
                  <option value="pfe-skt-annual">PFE-SKT Annual</option>
                  <option value="pfe-only-semi">PFE Only Semi-Annual</option>
                  <option value="pfe-only-annual">PFE Only Annual</option>
                </select>
              </div>
              {guestAccountType && isEditingExistingSchedule && (
                <div className="form-group">
                  <label>Expiration Date</label>
                  <SimpleDatePicker
                    date={this.state.guestAccountExpiration}
                    onChange={(date) =>
                      this.setState({ guestAccountExpiration: date })
                    }
                    minDate={
                      new Date(Number(profile.guestAccountScheduledStart))
                    }
                    className="form-control"
                  />
                </div>
              )}
              {guestAccountType && !isEditingExistingSchedule && (
                <p className="text-muted" style={{ marginTop: '10px' }}>
                  The expiration date will be calculated automatically based on
                  the account type. You'll be able to adjust it later.
                </p>
              )}
              <p className="text-muted" style={{ marginTop: '10px' }}>
                If the user's current subscription is still active, the free
                period will start once it ends. If it's already expired, the
                free period will start immediately.
              </p>
              {profile.transactionIosId && (
                <p className="text-danger" style={{ marginTop: '8px' }}>
                  This user has an Apple subscription. Remind them to cancel it
                  manually from their device before current period ends.
                </p>
              )}
            </div>
          )}
          {isGuestActive && (
            <div>
              <div className="form-group">
                <label>
                  <input
                    type="checkbox"
                    checked={guestAccountChecked}
                    onChange={(e) =>
                      this.setState({ guestAccountChecked: e.target.checked })
                    }
                    style={{ marginRight: '8px' }}
                  />
                  Free Account
                </label>
              </div>
              {guestAccountChecked && (
                <div className="form-group">
                  <label>Expiration Date</label>
                  <SimpleDatePicker
                    date={this.state.guestAccountExpiration}
                    onChange={(date) =>
                      this.setState({ guestAccountExpiration: date })
                    }
                    className="form-control"
                  />
                </div>
              )}
              {!guestAccountChecked && (
                <div>
                  <div className="form-group">
                    <label>Stripe ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={guestStripeId}
                      onChange={(e) =>
                        this.setState({ guestStripeId: e.target.value })
                      }
                      placeholder="Optional"
                    />
                  </div>
                  <div className="form-group">
                    <label>Transaction ID</label>
                    <input
                      type="text"
                      className="form-control"
                      value={guestTransactionId}
                      onChange={(e) =>
                        this.setState({ guestTransactionId: e.target.value })
                      }
                      placeholder="Optional"
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {isGuestActive && (
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => this.onCancelGuestPeriod()}
            >
              Cancel Free Period
            </button>
          )}
          <button
            type="button"
            className="btn btn-success"
            disabled={saveDisabled}
            onClick={() => this.onSaveGuestAccount()}
          >
            Save
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={closeModal}
          >
            Cancel
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  render() {
    const { permissions } = this.props;
    return (
      <div className="userCardsContainer">
        <Card
          title="Student"
          content={this.cardContent(permissions)}
          options={this.getOptions(permissions)}
        />
      </div>
    );
  }
}

export default addAbilityToOpenModal(UserProfile);
